export default (context: any) => {
  // return true if user is admi
  if (!context.$auth.$state.user.is_admin) {
    context.redirect('/overview/buses/')
  }
}
